import * as React from "react";
type Props = {
  className?: string,
};
function SvgWasteLessFood({ className }: Props) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-WasteLessFood"
      className={className}
    >
      <path
        d="M10.2 7.20001V26.4"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M25.8 20.4C28.4509 20.4 30.6 17.4451 30.6 13.8C30.6 10.1549 28.4509 7.20001 25.8 7.20001C23.1491 7.20001 21 10.1549 21 13.8C21 17.4451 23.1491 20.4 25.8 20.4Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M25.8 26.4V20.4"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M5.40002 7.20001V17.6026C5.40002 18.4848 6.2343 19.2 7.26342 19.2H13.1367C14.1658 19.2 15 18.4848 15 17.6026V7.20001"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M34.8 20.1156C37.9756 20.6022 40.2728 23.5052 40.1293 26.7018C39.9952 29.6843 37.7682 32.2354 34.8138 32.6888V38.4C35.2871 38.3404 41.8734 37.3816 44.5598 31.3879C46.1837 27.7655 45.4786 24.3824 45.2532 23.4611C44.2397 19.3212 41.1832 16.3188 37.9427 15.0808C36.7079 14.6086 35.6019 14.4518 34.8117 14.4C34.8075 16.3056 34.8042 18.21 34.8 20.1156Z"
        fill="currentColor"
      />
      <path
        d="M11.4 26.4H9.00005C8.33731 26.4 7.80005 26.9373 7.80005 27.6V40.8C7.80005 41.4627 8.33731 42 9.00005 42H11.4C12.0628 42 12.6 41.4627 12.6 40.8V27.6C12.6 26.9373 12.0628 26.4 11.4 26.4Z"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M27 26.4H24.6C23.9373 26.4 23.4 26.9373 23.4 27.6V40.8C23.4 41.4627 23.9373 42 24.6 42H27C27.6628 42 28.2 41.4627 28.2 40.8V27.6C28.2 26.9373 27.6628 26.4 27 26.4Z"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
}
export default SvgWasteLessFood;
